module.exports = __webpack_public_path__ + "media/assets/images/dots-859f21f20537872ac1b0fbec81499e8c.svg";